import React, { useState } from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import arquitect_1 from "../../images/arquitect_1.jpeg";
import arquitect_2 from "../../images/arquitect_2.jpeg";
import arquitect_3 from "../../images/arquitect_3.jpeg";
import arquitect_4 from "../../images/arquitect_4.jpeg";
import arquitect_5 from "../../images/arquitect_5.jpeg";
import arquitect_6 from "../../images/arquitect_6.jpeg";
import arquitect_7 from "../../images/arquitect_7.jpeg";
import arquitect_8 from "../../images/arquitect_8.jpeg";
import arquitect_9 from "../../images/arquitect_9.jpeg";
import arquitect_10 from "../../images/arquitect_10.jpeg";

import "./Carousel.css";

export default function Carousel() {

    const images = [
        { src: arquitect_1, id: 0, text: "Excelente exposição solar" },
        { src: arquitect_2, id: 1, text: "O futuro é hoje" },
        { src: arquitect_3, id: 2, text: "Acabamentos de qualidade" },
        { src: arquitect_4, id: 3, text: "Design moderno e funcional" },
        { src: arquitect_5, id: 4, text: "Não esquecemos dos detalhes" },
        { src: arquitect_6, id: 5, text: "Imagine-se a desfrutar da sua casa" },
        { src: arquitect_7, id: 6, text: "Bem vindo" },
        { src: arquitect_8, id: 7, text: "Trabalho, amigos ou lazer" },
        { src: arquitect_9, id: 8, text: "'Onde as nossas histórias são escritas'" },
        { src: arquitect_10, id: 9, text: "Isolamento acústico e térmico" },
    ];

    const [activeImg, setActiveImg] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const imgClick = (e) => {
        e.preventDefault();
        setActiveImg(parseInt(e.target.id));
        setIsOpen(true);
    }

    const carousel = () => {
        return (
            <div className="container-fluid px-0 cardcontainer" id="picturesContainer">
                <div id="carouselExampleControls" interval={5000} className="carousel slide" data-ride="carousel" data-pause={false}>
                    <div className="carousel-inner bg-info" role="listbox">
                        {images.map(element =>
                            element.id === activeImg ?
                                (
                                    <div className={"carousel-item active"} key={element.id} style={{backgroundColor: "#b4f3e3"}}>
                                        <div className="d-flex align-items-center justify-content-center min-vh-100">
                                            <img className="d-block w-100 slideshow" onClick={imgClick} id={element.id} src={element.src} alt={element.id} mode="fit"

                                            />
                                        </div>
                                    </div>

                                ) :
                                (
                                    <div className={"carousel-item"} key={element.id}>
                                        <div className="d-flex align-items-center justify-content-center min-vh-100">
                                            <img className="d-block w-100 slideshow" onClick={imgClick} id={element.id} src={element.src} alt={element.id} mode="fit"
                                            />
                                        </div>
                                    </div>

                                )
                        )}
                    </div>
                    <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </div>
            </div>
        )
    }

    const lightbox = () => {
        const imgIndex1 = activeImg === 0 ? images.length - 1 : activeImg - 1;
        const imgIndex2 = activeImg === images.length - 1 ? 0 : activeImg + 1;
        return (
            <div>
                {isOpen && (
                    <Lightbox
                        mainSrc={images[activeImg].src}
                        nextSrc={images[imgIndex2].src}
                        prevSrc={images[imgIndex1].src}
                        onCloseRequest={() => setIsOpen(false)}
                        onMovePrevRequest={() =>
                            setActiveImg(imgIndex1)
                        }
                        onMoveNextRequest={() =>
                            setActiveImg(imgIndex2)
                        }
                    />
                )}
            </div>
        );
    }

    return (
        <div id="containerVideoElements">
            {carousel()}
            {lightbox()}
        </div>
    )
}
